import React from 'react';
import ReservationCalendar from './ReservationCalendar';

const CalendarPage: React.FC = () => (
  <div style={{ padding: 0 }}>
    <ReservationCalendar showEvents />
  </div>
);

export default CalendarPage;
